import React from "react";
import type { Configuration } from "../../model/Configuration";
import useConfiguration from "../../redux/Hooks/Kiosk/useConfiguration";
import { configurationChangeAction } from "../../redux/Actions";
import { useDispatchKiosk } from "../../redux/Hooks/Kiosk/useDispatchKiosk";
import { useLocale } from "@davi-ai/retorik-framework";
import translation from '../../translations/subMenuItems.json';
import commonTranslation from '../../translations/common.json';
import Button from "../Common/Button";
import tempConfigurationChangeAction from "../../redux/Actions/Kiosk/tempConfigurationChangeAction";

const SkipWelcome = () => {
  const locale = useLocale();
  const dispatch = useDispatchKiosk();
  const configuration = useConfiguration();
  const label = configuration.skipWelcome === true
    ? commonTranslation[locale]?.enable || commonTranslation["fr-FR"].enable
    : commonTranslation[locale]?.disable || commonTranslation["fr-FR"].disable;

  const toggleSkipWelcome = () => {
    const current = configuration.skipWelcome === true;
    var temp: Configuration = { ...configuration };
    temp.skipWelcome = !current;

    dispatch(configurationChangeAction(temp));
    dispatch(tempConfigurationChangeAction({ skipWelcome: !current }));
  };

  return (
    <div className="w-full flex flex-col gap-4 mt-6">
      {translation[locale]?.welcome.title || translation["fr-FR"].welcome.title}
      <Button label={label} onClick={toggleSkipWelcome}>
        {label}
      </Button>
    </div>
  );
};

export default SkipWelcome;
